import { render, staticRenderFns } from "./MissionStatement.vue?vue&type=template&id=1dc52bb5"
import script from "./MissionStatement.vue?vue&type=script&lang=js"
export * from "./MissionStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports